/* Canigloo — Blog « Conseils chien & été ».
   Source : Structure_page_blog_Shopify_Canigloo.md (structure Yomi).
   4 articles de lancement, maillage vers IceDream. */

window.CG_BLOG_DATA = {
  articles: [
    {
      id: 'rafraichir',
      url: '/blogs/conseils-chien-ete/comment-rafraichir-son-chien',
      tag: 'Chaleur',
      title: 'Comment rafraîchir son chien : 9 astuces qui marchent vraiment',
      excerpt: "Des gestes simples pour le soulager dès aujourd'hui : eau, ombre, coin frais, horaires de balade. Sans clim, sans prise de tête.",
      time: '5 min',
      cover: null,
      icon: 'IconWind',
    },
    {
      id: 'coup-de-chaleur',
      url: '/blogs/conseils-chien-ete/coup-de-chaleur-chien',
      tag: 'Canicule',
      title: 'Coup de chaleur chez le chien : signes, bons réflexes et erreurs à éviter',
      excerpt: "Quoi regarder, quoi faire, et quand demander de l'aide. Le guide à lire avant les grosses chaleurs.",
      time: '8 min',
      cover: window.CG_ASSET('blog-1.png'),
      featured: true,
      featuredText: "Quand ton chien a chaud, tu n'as pas besoin d'un discours compliqué. Tu as besoin de savoir quoi regarder, quoi faire, et quand demander de l'aide.",
    },
    {
      id: 'symptomes',
      url: '/blogs/conseils-chien-ete/symptomes-coup-de-chaleur-chien',
      tag: 'Canicule',
      title: 'Symptômes du coup de chaleur chez le chien : les signes à repérer',
      excerpt: 'Halètement, fatigue, comportement inhabituel : les signaux à surveiller sans paniquer.',
      time: '4 min',
      cover: null,
      icon: 'IconShield',
    },
    {
      id: 'meilleur-tapis',
      url: '/blogs/conseils-chien-ete/meilleur-tapis-rafraichissant-chien',
      tag: 'Tapis rafraîchissant',
      title: 'Meilleur tapis rafraîchissant chien : coton respirant, avis et choix 2026',
      excerpt: 'Matière, taille, entretien, avis : comment choisir sans te faire avoir.',
      time: '6 min',
      cover: window.CG_ASSET('blog-2.png'),
    },
  ],
  start: [
    {
      title: "Il fait chaud aujourd'hui",
      text: 'Les gestes simples pour le soulager maintenant, sans clim et sans prise de tête.',
      target: 'rafraichir',
      icon: 'IconWind',
    },
    {
      title: 'Tu veux reconnaître les signes',
      text: 'Halètement, fatigue, comportement inhabituel : les signaux à surveiller sans paniquer.',
      target: 'symptomes',
      icon: 'IconShield',
    },
    {
      title: 'Tu hésites sur un tapis',
      text: 'Matière, taille, entretien, avis : comment choisir sans te faire avoir.',
      target: 'meilleur-tapis',
      icon: 'IconBed',
    },
  ],
};
